import React, { useEffect, useState } from 'react';
import { useGDPRConsent } from '../hooks/useGDPRConsent';
import TermsModal from './TermsModal';

export default function GDPRConsent() {
  const { hasConsent, setConsent, isInitialized } = useGDPRConsent();
  const [isVisible, setIsVisible] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [checked3, setChecked3] = useState(false);

  useEffect(() => {
    // Only show the GDPR modal if we've checked localStorage and the user hasn't consented
    if (isInitialized && !hasConsent) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [hasConsent, isInitialized]);

  const handleAccept = () => {
    setConsent(true);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-[95vw] sm:max-w-2xl relative min-h-[40vh] max-h-[90vh] flex flex-col">
        <div className="p-6 overflow-y-auto flex-1">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            Politica de Confidențialitate și GDPR
          </h2>
          
          <div className="prose prose-sm text-gray-600 mb-6">
            <p>Pentru a vă oferi cele mai bune servicii și pentru a măsura eficiența campaniilor noastre de marketing, Decizie Oncologica procesează date cu caracter personal în conformitate cu Regulamentul General privind Protecția Datelor (GDPR).</p>
            
            <p>Prin utilizarea platformei noastre, sunteți de acord cu:</p>
            <ul className="list-disc ml-6 mb-4">
              <li>Colectarea și procesarea datelor medicale pentru scopul furnizării serviciilor medicale</li>
              <li>Stocarea securizată a documentelor medicale încărcate</li>
              <li>Transmiterea informațiilor către echipa medicală pentru analiză</li>
              <li>Utilizarea cookie-urilor și a tehnologiilor similare pentru îmbunătățirea experienței utilizatorilor și măsurarea eficienței campaniilor de marketing</li>
            </ul>
            
            <p className="font-bold mb-4">Confirm că:</p>
            <div className="space-y-2 mb-4">
              <label className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  checked={checked1}
                  onChange={(e) => setChecked1(e.target.checked)}
                  className="h-4 w-4"
                />
                ✔️ Am citit și înțeleg modul în care platforma funcționează.
              </label>
              <label className="flex items-center gap-2">
                <input 
                  type="checkbox" 
                  checked={checked2}
                  onChange={(e) => setChecked2(e.target.checked)}
                  className="h-4 w-4"
                />
                ✔️ Accept ca datele mele să fie utilizate strict în scop medical, conform procedurilor descrise.
              </label>
              <label className="inline-flex items-center gap-2">
                <input 
                  type="checkbox" 
                  checked={checked3}
                  onChange={(e) => setChecked3(e.target.checked)}
                  className="h-4 w-4"
                />
                <span className="text-wrap">
                  ✔️ Sunt de acord cu prelucrarea datelor și îmi acord consimțământul<br/> 
                  pentru folosirea platformei conform condițiilor din capitolul 8 din{' '}
                  <button 
                    onClick={() => setShowTerms(true)} 
                    className="text-[#024994] hover:underline"
                  >
                    termeni și condiții.
                  </button>
                </span>
              </label>
            </div>

            <p className="italic text-orange-600 mb-4">
              Pentru a continua, trebuie să bifați căsuțele de mai sus și să confirmați consimțământul.
            </p>

            <p className="text-sm text-gray-600 mb-4">
              <span className="font-bold">Drepturile dumneavoastră:</span><br/>
              Puteți retrage consimțământul sau solicita ștergerea datelor în orice moment, scriind la {' '}
              <a href="mailto:contact@decizieoncologica.ro" className="text-[#024994] hover:underline">
                contact@decizieoncologica.ro
              </a>.<br/>
              Detalii complete găsiți în <span className="whitespace-nowrap"><button 
                onClick={() => setShowTerms(true)} 
                className="text-[#024994] hover:underline"
              >
                termeni și condiții
              </button></span>.
            </p>
          </div>

          <div className="sticky bottom-0 bg-gradient-to-t from-white via-white/90 to-white/50 pt-4">
            <div className="flex justify-center pb-4">
              <button
                onClick={handleAccept}
                className="px-6 py-2 bg-[#024994] text-white rounded-lg hover:opacity-90 transition disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={!checked1 || !checked2 || !checked3}
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>

      <TermsModal 
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
      />
    </div>
  );
}
